import { useTheme } from "next-themes";

export default function useThemeToggle() {
    const { theme, setTheme } = useTheme();

    const mode: "light" | "dark" = theme === "dark" ? "dark" : "light";

    const toggleTheme = () => {
        setTheme(mode === "dark" ? "light" : "dark");
    };

    return { toggleTheme, mode, setTheme };
}
